module.exports = __webpack_public_path__ + "static/media/check.cb619ed1.svg";